// extracted by mini-css-extract-plugin
export default {"button":"IssueButton_button__DHCRm"};